import React, { lazy, Suspense, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
//css
import "@/Styles/Carrusel.css";
import "@/Styles/ModalDevelop.css";
import useWindowsSize from "@/Hooks/useWindowsSize";
import { useBodyScroll } from "@/Hooks/Scroll/useBodyScroll";
import {
  DefaultPdp,
  HeaderPlpMovil,
  HeaderPlpWeb,
  Navegation,
  NavMovil,
  NewBuy2,
  ProductDetailView,
} from "@/Components/Index";
import { LayoutPdp } from "@/Layout";
import { ProductImageView } from "@/Components/ViewProduct/ProductImageView/ProductImageView";
import { mapperToBuyProduct } from "@/Mappers/BuyProduct.mapper";
import { useViewInfoProduct, useAddToCardBuy } from "@/Service/Api/Index";
import { ReplaceCharacterRest } from "@/Utils/RemplaceCharacter";

const LazyHeaderWeb = lazy(() => import("@/Components/Header/HeaderWeb"));
const LazyHeaderMovil = lazy(() => import("@/Components/Header/HeaderMovil"));

type paramsData = { id?: string; cteg?: string; subcateg?: string };

const stylesd: React.CSSProperties = { maxWidth: "233px" };

const PdpArticles: React.FC = () => {
  //Obtenemos los datos de url por medio de los parametro de useParams
  const { id, cteg, subcateg } = useParams<paramsData>();
  const { mDatos, isLoading } = useViewInfoProduct(id!, cteg!, subcateg!);
  const { postData, buyCardSku } = useAddToCardBuy();
  //Modal
  const [showModal, setShowModal] = useState<boolean>(false);
  //screen de pantalla
  const { width } = useWindowsSize();
  //Quantity de Articulos
  const [TQuantity, setTQuantity] = useState<number>(0);
  //Status to button
  const [statusButton, setStatusButton] = useState<boolean>(false);
  //link
  let urlInicio = "/Electrónica";
  let urls = `${urlInicio}/${cteg}`;
  const navigate = useNavigate();
  //Habilitar o no el scroll cuando se usa el modal.
  useBodyScroll(showModal);

  /*********** ENVIO DE DATOS  ****************/
  const createBasketOrderBuy = async () => {
    let quantityArticle = TQuantity > 0 ? TQuantity : 1;

    const buyProduct = mapperToBuyProduct(mDatos, quantityArticle);

    setStatusButton(true);

    const resp = await postData(buyCardSku, buyProduct).finally(() =>
      setStatusButton(false)
    );

    const nameProduct = ReplaceCharacterRest(mDatos[0]?.Name!);

    if (!isLoading) {
      navigate(
        `/Electrónica/${cteg}/${subcateg}/checkout/storeId/buy/${id}/c/n/${nameProduct}/cant/${quantityArticle}`
      );
    }
  };

  /****** Quantity ******/
  const handdlesQuantity = (unidad: number) => {
    setTQuantity(unidad);
  };

  /******** Modal de imagenes ***********/
  const openCloseModal = (valor: boolean) => setShowModal(valor);
  /******** end modal ************/

  return (
    <Suspense>
      {showModal ? (
        ""
      ) : width >= 1200 ? (
        <LazyHeaderWeb>
          <HeaderPlpWeb
            titles={""}
            toLink={`${urls}/${subcateg}`}
            classNamesIcon={"icon-question-circle text-white"}
          />
        </LazyHeaderWeb>
      ) : (
        <LazyHeaderMovil>
          <NavMovil classNames={"align-items-center"}>
            <HeaderPlpMovil
              toLink={`${urls}/${subcateg}`}
              title={""}
              toIcon={"/"}
            />
          </NavMovil>
        </LazyHeaderMovil>
      )}
      <Navegation
        classNames="ps-container"
        isLoading={isLoading}
        toLinkOne={"/"}
        toLinkTwo={"/Electrónica"}>
        {isLoading ? (
          <Skeleton height={20} />
        ) : (
          <>
            <li className="text-truncate">
              <Link to={`${urls}/${subcateg}`} className="link__develop">
                {
                  //mDatos[0]?.SubCategory
                  subcateg
                }
              </Link>
            </li>
            <li className="text-truncate" style={width < 460 ? stylesd : {}}>
              {mDatos[0]?.Name}
            </li>
          </>
        )}
      </Navegation>

      <LayoutPdp>
        {isLoading ? (
          <DefaultPdp />
        ) : (
          <div className="ps-product--detail ps-product--fullwidth">
            <div className="ps-product__header container__thumbnail">
              <ProductImageView
                mDatos={mDatos}
                openModal={showModal}
                onClickModal={openCloseModal}
                isLoading={isLoading}
              />
            </div>
            {
              <ProductDetailView
                mDatos={mDatos}
                onClicksQunatity={handdlesQuantity}
                onClickBuy={createBasketOrderBuy}
                isLoadingActiveButton={statusButton}
              />
            }
          </div>
        )}
      </LayoutPdp>
      {showModal ? (
        ""
      ) : width < 1200 ? (
        <div className="button-fixed">
          {isLoading ? (
            <Skeleton className="ps-btn develop__buttons btn__develop__movil" />
          ) : (
            <NewBuy2
              title={"Comprar Ahora"}
              toStatus={statusButton}
              movilWeb={false}
              onClicks={createBasketOrderBuy}
              isLoadingClickBtn={statusButton}
            />
          )}
        </div>
      ) : (
        ""
      )}
      <br />
    </Suspense>
  );
};

export default PdpArticles;
